var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34 42.0006C30.6926 41.9976 27.4366 41.1802 24.52 39.6206L23.62 39.1206C17.4015 35.7772 12.3034 30.679 8.96 24.4606L8.46 23.5606C6.85964 20.6274 6.01426 17.3419 6 14.0005V12.6605C5.99916 11.5945 6.42392 10.5721 7.18 9.82053L10.56 6.44053C10.8883 6.10973 11.3516 5.9503 11.8139 6.00906C12.2762 6.06782 12.685 6.33814 12.92 6.74054L17.42 14.4605C17.8751 15.2463 17.7437 16.2401 17.1 16.8805L13.32 20.6606C13.0061 20.971 12.9329 21.4506 13.14 21.8406L13.84 23.1606C16.3541 27.8174 20.1786 31.635 24.84 34.1406L26.16 34.8606C26.55 35.0676 27.0296 34.9944 27.34 34.6806L31.12 30.9006C31.7604 30.257 32.7542 30.1256 33.54 30.5806L41.26 35.0806C41.6624 35.3156 41.9328 35.7244 41.9914 36.1866C42.0502 36.649 41.8908 37.1124 41.56 37.4406L38.18 40.8206C37.4284 41.5766 36.406 42.0014 35.34 42.0006H34Z",
    fill: "#00009F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f1e38180c874975cd639006630c13a87.svg";
export { ForwardRef as ReactComponent };